import { render, staticRenderFns } from "./ProductTextLanguagesDialog.vue?vue&type=template&id=9b83ade2&scoped=true&lang=pug&"
import script from "./ProductTextLanguagesDialog.vue?vue&type=script&lang=ts&"
export * from "./ProductTextLanguagesDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ProductTextLanguagesDialog.vue?vue&type=style&index=0&id=9b83ade2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b83ade2",
  null
  
)

export default component.exports